export const pgcgposition = {
  PEER_GROUPS_INDEX: 2,
  CUSTOM_GRADES_INDEX: 3
};

export const pgcgtags = {
  PEER_GROUPS: "Peer Groups",
  CUSTOM_GRADES: "Custom Grades"
};
